import lazyLoading from './lazyLoading'

export default {
  name: 'Central Page',
  path: '/homenet/centralpage',
  redirect: '/homenet/centralpage/list',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: lazyLoading('homenet', true),
  children: [
    {
      'name': 'List',
      'path': 'list',
      'meta': {
        'label': 'List'
      },
      'component': lazyLoading('homenet/CentralPage')
    }
  ]
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/centralPage.js